// tslint:disable:max-line-length
export const PRODUCTNAME = 'Zeotap GDPR';
export const ZCOOKIE = 'zc';
export const TEXT = {
  cancel: 'Cancel',
  adIdText: 'Your Advertising ID (*) is:',
  yourData: 'zeotap collects the following categories of User Data from our Data Partners.',
  userDataList: [
    '-Demographic information like age, gender, city/region, income, language and mobile contract data such as prepaid/postpaid (“Demographic Data”)',
    '-Mobile app usage data about apps installed/accessed on a user’s device and app events and browsing data such as browsing URLs (“App Usage and Browsing Data”)',
    '-Purchase data',
    '-Generalized location data.',
  ],
  userCategoryHeading: 'The User Data is stored against one or more of following IDs',
  userCategoryData: [
    '-Mobile advertising device IDs such as Apple’s Identifier For Advertisers (IDFA) and Google Advertising ID (“Advertising ID / Ad ID”) depending on which device you are using',
    '-Cookie IDs',
    '-Hashed email addresses and hashed telephone numbers.'
  ],
  emailData: 'Email Your Data',
  sendEmail: 'Send Email',
  appDescription: 'At zeotap, we believe everyone should have full transparency about their personal data / personal information and how it is used to optimized the advertising experience. This app was created to facilitate the exercise of your rights and will enable you to easily access what data zeotap is processing for the purpose of targeted mobile advertising and furthermore give you an easy opt-out possibility that goes along with the deletion of your data.',
  // noCookie: 'There is no zeotap Cookie associated to your browser.',
  noCookie: [
    'zeotap could not identify any Cookie ID, used for the purposes as described in our Products and Services Privacy Policy',
    'However, visiting our website (',
    '), zeotap may have set cookies for the purpose of zeotap analytics and zeotap advertising as described in our Website Privacy Policy',
    'You can delete such cookies at any time by clearing or blocking our cookies in the settings of all of your used browsers or you can easily opt-out by using our CMP Usercentrics, clicking on the icon available at the bottom of every page of our website:'
  ],
  deletedText: 'Your data has been deleted.',
  optoutStatus: 'Your opt out request has been registered on *. Your data will be deleted by *.',
  successMsg: 'we will send an email with you date in next 7 days along with csv file.',
  infoMsg: 'We will delete your data from our system within 30 days.',
  // noData: 'No data associated to your Advertising ID (*) is stored in our systems.',
  noData: 'zeotap could identify a * as shown above, however no additional Personal Data, processed for the purposes as described in our Products and Services Privacy Policy',
  noDataText: 'is stored against the mentioned Cookie ID. The reason might be that (i) you either have deleted your data already, (ii) changed the settings of your browser, (iii) limited the ad tracking in your browser. For instructions on how to limit the ad tracking, please refer to our Products and Services Privacy Policy.',
  dataInfo: 'In order to find out what exact User Data zeotap stores against your identifiers, please click “EMAIL MY DATA” and zeotap will provide you with a list of all your personal data stored in our systems within the next 7 working days. ',
  webPlatform: '1',
  platformAndroid: '3',
  platformIOS: '2',
  exitText: 'Exit',
  refresh: 'Refresh',
  idMap: {
    1: 'Cookie ID',
    2: 'IDFA',
    3: 'Google Advertising ID'
  },
  optin: 'OPT ME IN',
  optInThanksMessage: 'Thanks for choosing to opt in. we will use your data only for advertising purposes and we don’t share it with anyone.',
  setting_1: 'To opt in please open',
  setting_2_ios: 'Settings > Privacy > Adverstising',
  setting_2_android: 'Settings > Google > Adverstising',
  setting_3: 'and reset your advertising ID.',
  custom: {
    company: {
      heading: 'Company',
      primaryDesc: 'WE UNITE THE WORLD\'S MOST VALUABLE DATA TO FUEL GROWTH',
      secondaryDesc: 'Achieving better results through high-quality data at scale and intelligent technology. The first company to win major telecom operators as data partners around the world, zeotap today has become the leader in sourcing, refining & distributing high-value data from enterprise sources. Founded in Berlin in 2014, zeotap today has offices all over the globe and counts many of the world\'s most prestigious brands amongst its clients.'
    },
    publishers: {
      heading: 'Publishers',
      primaryDesc: 'Get The Most Out of Your Mobile Inventory',
      secondaryDesc: 'Wow the world\'s most demanding brands with up to 6x better on-target reach. Win over large TV budgets and maximize the number of your targeted impressions. Sell high-precision audiences and realize higher eCPMs on long-tail inventory.'
    },
    advertisers: {
      heading: 'Advertisers',
      primaryDesc: 'Activate Ultimate Data Performance.',
      secondaryDesc: 'We are bringing the most exclusive data together for you. Telecom operators, software security providers, payroll companies - we only tap into the best sources.We understand you need high-quality data and lots of it. All of our data meets high quality standards and gets united it in a single platform for maximum impact. Master On-Target-Reach, engagement and conversions. We want you to achieve consistently better outcomes. It\'s what all of this is about.'
    }
  }
};
export const MESSAGES = {
  'ERROR': 'Some error occurred. Please try again.',
};
export const STATUS = {
  OptedOutInProgress: 'OPTED_OUT_IN_PROGRESS',
  OptedOut: 'OPTED_OUT'
};
export const productLinks = [
  {
    name: 'Company',
    url: '/custom',
    params: 'company'
  },
  {
    name: 'Advertisers',
    url: '/custom',
    params: 'advertisers'
  },
  {
    name: 'Publishers',
    url: '/custom',
    params: 'publishers'
  },
  {
    name: 'Privacy Policy',
    url: '/policy',
  },
  {
    name: 'Opt out',
    url: '/authentication'
  }
];



// WEBPACK FOOTER //
// ./src/app/app.const.ts